import { usePerson } from '../../contexts/PersonContext'
import { SectionLabel } from '../ui/SectionLabel'
import { NavRow } from './NavRow'

interface CommunityItem {
  label: string
  to: string
  badge?: number | string
}

/** "Community" sidebar section — Safety centre is parent-only. */
export function CommunitySection() {
  const { role, counters } = usePerson()

  const items: CommunityItem[] =
    role === 'parent'
      ? [
          { label: 'Report a member', to: '/report' },
          { label: 'Safety centre', to: '/safety', badge: counters.openReports },
          { label: 'The kindness code', to: '/rules' },
          { label: 'About & help', to: '/about' },
        ]
      : [
          { label: 'Report a member', to: '/report' },
          { label: 'The kindness code', to: '/rules' },
          { label: 'About & help', to: '/about' },
        ]

  return (
    <div className="flex flex-col gap-1">
      <div className="px-[10px] pb-[2px]">
        <SectionLabel>Community</SectionLabel>
      </div>
      {items.map((item) => (
        <NavRow key={item.to} label={item.label} to={item.to} badge={item.badge} badgeLabel={item.badge === 1 ? 'open report' : 'open reports'} />
      ))}
    </div>
  )
}
